import { __assign, __rest } from "tslib";
/* eslint-disable react/display-name */
import React, { useCallback, useRef, useState } from 'react';
import { forwardRef } from '../helpers/forwardRef';
import { IconDataTids } from './Icon';
import { isDocument, isShadowRoot, ZERO_WIDTH_SPACE } from './utils';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
export var BaseIcon = forwardRef('BaseIcon', function (_a, ref) {
    var color = _a.color, size = _a.size, style = _a.style, _b = _a["aria-hidden"], ariaHidden = _b === void 0 ? true : _b, _c = _a.viewBoxSize, viewBoxSize = _c === void 0 ? 16 : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, children = _a.children, tabIndex = _a.tabIndex, onKeyUp = _a.onKeyUp, onBlur = _a.onBlur, rest = __rest(_a, ["color", "size", "style", 'aria-hidden', "viewBoxSize", "align", "children", "tabIndex", "onKeyUp", "onBlur"]);
    var zeroWidthSpaceRef = useRef(null);
    var _e = useState(false), focusVisible = _e[0], setFocusVisible = _e[1];
    useIsomorphicLayoutEffect(function () {
        var element = zeroWidthSpaceRef.current;
        if (!element || !element.attachShadow) {
            return;
        }
        var zeroWidthSpace = element.ownerDocument.createElement('span');
        element.append(zeroWidthSpace);
        try {
            var shadow = zeroWidthSpace.attachShadow({ mode: 'closed' });
            shadow.textContent = ZERO_WIDTH_SPACE;
        }
        catch (e) {
            console.error(e);
        }
        return function () { return zeroWidthSpace.remove(); };
    }, [zeroWidthSpaceRef.current]);
    var enableFocusVisibleOnTab = useCallback(function (e) {
        var root = e.currentTarget.getRootNode();
        if (!focusVisible &&
            e.key === 'Tab' &&
            (isDocument(root) || isShadowRoot(root)) &&
            root.activeElement === e.currentTarget) {
            setFocusVisible(true);
        }
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
    }, [focusVisible, onKeyUp]);
    var disableFocusVisible = useCallback(function (e) {
        focusVisible && setFocusVisible(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [focusVisible, onBlur]);
    var icon = (React.createElement("svg", __assign({ "data-tid": IconDataTids.root, ref: ref, width: size || viewBoxSize, height: size || viewBoxSize, style: __assign({ fill: color !== null && color !== void 0 ? color : 'currentColor', marginBottom: align === 'none' || align === 'center' ? 0 : '-0.1875em', flexShrink: 0, outline: focusVisible ? undefined : 'none' }, (align !== 'center' ? style : {})), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize), "aria-hidden": ariaHidden, tabIndex: tabIndex, onKeyUp: enableFocusVisibleOnTab, onBlur: disableFocusVisible }, rest), children));
    if (align === 'center') {
        return (React.createElement("span", { "aria-hidden": ariaHidden, style: __assign({ display: 'inline-flex', alignItems: 'center' }, style) },
            React.createElement("span", { ref: zeroWidthSpaceRef }),
            icon));
    }
    return icon;
});
